// Lot 634 — émojis classés en 3 catégories (choix owner) : « Foi » · « Émotions » · « Vie & musique ».
// 24 émojis par catégorie (rangées pleines en 6 et en 8 colonnes). Union de toutes les anciennes grilles + instruments.
export const EMOJI_CATEGORIES = [
  {
    key: "faith", labelKey: "emoji.cat_faith", label: "Foi", icon: "🙏",
    emojis: ["🙏", "🙌", "✝️", "🕊️", "📖", "⛪", "📿", "🕯️", "👑", "✨", "🌟", "⭐", "☀️", "🌈", "🍞", "🐟", "🐑", "🌿", "💐", "🌹", "🤍", "🫶", "🤝", "😇"],
  },
  {
    key: "emotions", labelKey: "emoji.cat_emotions", label: "Émotions", icon: "😊",
    emojis: ["❤️", "💔", "😂", "🤣", "😊", "😍", "🥰", "😘", "😉", "😁", "🤩", "🤗", "😢", "😭", "😮", "😱", "👍", "👏", "💪", "🔥", "💯", "🎉", "🥳", "💌"],
  },
  {
    key: "life", labelKey: "emoji.cat_life", label: "Vie & musique", icon: "🎸",
    emojis: ["✈️", "🚗", "🚌", "🏠", "🎓", "⚽", "🚀", "🌍", "🎂", "🎁", "👶", "☕", "🎸", "🥁", "🎹", "🎺", "🎷", "🎻", "🎤", "🎧", "🎼", "🎵", "🎶", "📱"],
  },
];

export const ALL_EMOJIS = EMOJI_CATEGORIES.flatMap((c) => c.emojis);

const TAB_KEY = "yalola.emojiTab";
export const readEmojiTab = () => {
  try { const v = localStorage.getItem(TAB_KEY); return EMOJI_CATEGORIES.some((c) => c.key === v) ? v : EMOJI_CATEGORIES[0].key; } catch { return EMOJI_CATEGORIES[0].key; }
};
export const writeEmojiTab = (key) => { try { localStorage.setItem(TAB_KEY, key); } catch { /* noop */ } };
